import * as types from './mutations';

export const actions = {
  async 'auth.providerLogin'({ commit, dispatch }, { OAuthToken, offlineCode, scope, provider, resumeId }) {
    const result = await this.$axios.$get(`auth/${provider}/token`, {
      headers: { Authorization: `Bearer ${OAuthToken}` },
      params: { offlineCode, scope, resumeId },
    });
    commit(types.LOGIN, result.accessToken);

    this.$axios.setHeader('Authorization', `Token ${result.accessToken}`);
    await dispatch('auth.updateUser');
  },
  async 'auth.loginWithGoogle'({ commit, dispatch }, { offlineCode }) {
    const result = await this.$axios.$get(`auth/google/token`, {
      params: { offlineCode },
    });
    commit(types.LOGIN, result.accessToken);

    this.$axios.setHeader('Authorization', `Token ${result.accessToken}`);
    await dispatch('auth.updateUser');
  },
  async 'auth.setAccessToken'(_, accessToken) {
    this.$axios.setHeader('Authorization', `Token ${accessToken}`);
  },

  async 'auth.login'({ commit, dispatch }, { email, password }) {
    const result = await this.$axios.$post('/auth/login', { email, password });

    commit(types.LOGIN, result.accessToken);
    this.$axios.setHeader('Authorization', `Token ${result.accessToken}`);
    await dispatch('auth.updateUser');
  },

  async 'auth.register'(_, { email, password, firstname, lastname, resumeId }) {
    const result = await this.$axios.$post('/auth/register', {
      email,
      password,
      firstname,
      lastname,
      resumeId,
    });
    return result;
  },

  async 'auth.verifEmail'({ commit, dispatch }, token) {
    const result = await this.$axios.$post(`/auth/verif?token=${token}`);

    commit(types.LOGIN, result.accessToken);
    this.$axios.setHeader('Authorization', `Token ${result.accessToken}`);
    await dispatch('auth.updateUser');
  },
  async 'auth.askResetPassword'(_, email) {
    return this.$axios.$post(`/auth/password/claim?email=${encodeURIComponent(email)}`);
  },

  async 'auth.resetPassword'({ commit, dispatch }, { token, password }) {
    const result = await this.$axios.$put(`/auth/password?token=${token}`, {
      newPassword: password,
    });

    commit(types.LOGIN, result.accessToken);
    this.$axios.setHeader('Authorization', `Token ${result.accessToken}`);
    await dispatch('auth.updateUser');
  },

  async 'auth.logout'({ commit }) {
    this.$axios.setHeader('Authorization', false);
    commit(types.LOGOUT);
  },

  async 'auth.updateUser'({ commit, dispatch }) {
    let user = null;
    try {
      user = await this.$axios.$get('me');
    } catch (e) {
      return dispatch('auth.logout');
    }
    commit(types.UPDATE_USER, user);
  },

  async 'contacts.patchUser'(_, { id, Firstname, Lastname, PhoneNumber }) {
    const result = await this.$axios.$patch(`/me`, {
      Firstname,
      Lastname,
      PhoneNumber,
    });
    return result;
  },
  async 'user.addDevice'(_, token) {
    const result = await this.$axios.$post(`/me/devices`, {
      registrationId: token,
      device: {
        platform: navigator.userAgent,
      },
    });
    return result;
  },
};
